<script>  
  import Checkbox from '@itslearning/prometheus/assets/inputs/Checkbox/v1/Checkbox.svelte';
  import {questionAnswers} from '../../stores';

  export let question = { };
  export let questionAnswer = null;
  export let readonly = false;
  
  /**
   * set true if you do not want answer to be displayed, useful when e.g. printing survey
   * @type {boolean}
   */
  export let hideAnswer = false;

  $: answer = questionAnswer ? questionAnswer : $questionAnswers.find(a => a.questionId === question.questionId);
  
  function toggle(alternativeId) {
    if (hideAnswer) {
      return;
    }
    if (!answer.alternativeIds) {
      answer.alternativeIds = [alternativeId];
    }
    else {
      const i = answer.alternativeIds.indexOf(alternativeId);
      if (i >= 0) {
        answer.alternativeIds.splice(i, 1);
      }
      else {
        answer.alternativeIds.push(alternativeId);
      }
    }
  }

  function isSelected(answer, alternativeId) {
    if (hideAnswer) {
      return false;
    }
    return answer && answer.alternativeIds && answer.alternativeIds.includes(alternativeId);
  }
</script>


<ul class="alternatives-checkboxes">
  {#each question.alternatives as alternative}
  <li>
    <Checkbox 
        label={alternative.text} 
        checked={isSelected(answer, alternative.alternativeId)}
        small={true}
        on:change={() => toggle(alternative.alternativeId)}
        disabled={readonly}
        description={null}
        describedBy={null}
        >
    </Checkbox>
  </li>
  {/each}
</ul>
